import * as yup from 'yup'
import isEqual from 'lodash/isEqual'

import { REGEXP, VALUES } from 'utils/constants'
import { isInternalEmail, isRestrictedEmail, validateDocumentNumber } from 'utils/utils'

const CONTRIBUTOR = VALUES.ASSOCIATE_TYPE[0].value
const PROVIDER = VALUES.ASSOCIATE_TYPE[3].value
const emailErrorMessage = 'Introduzca una dirección de correo electrónico válida.'
const PROVIDER_WITH_INTERNAL_EMAIL_ERROR = 'Un colaborador no puede ser proveedor, dominio de correo no permitido.'
const RESTRICTED_EMAIL_ERROR = 'El correo no puede ser registrado, dominio de correo no permitido.'

export const validations = yup.object().shape({
   registerType: yup.string().required('El tipo de tercero es requerido'),
   legalNature: yup.string().when(['registerType'], {
      is: registerType => [CONTRIBUTOR, PROVIDER].includes(registerType),
      then: yup.string().required('Establezca una naturaleza jurídica'),
      otherwise: yup.string()
   }),
   documentType: yup.string().required('El tipo de identificación es requerido'),
   documentNumber: yup
      .string()
      .when('documentType', (documentType, schema, val) =>
         validateDocumentNumber(documentType, val.value)
            ? schema
            : schema.max(0, 'El número de caracteres NO es válido')
      )
      .required('El número de identificación es requerido'),
   email: yup
      .string()
      .required(emailErrorMessage)
      .matches(REGEXP.EMAIL, emailErrorMessage)
      .when('registerType', (registerType, schema, { value }) => {
         if (!isEqual(registerType, PROVIDER)) return schema
         if (isInternalEmail(value)) return schema.max(0, PROVIDER_WITH_INTERNAL_EMAIL_ERROR)
         if (isRestrictedEmail(value)) return schema.max(0, RESTRICTED_EMAIL_ERROR)
         return schema
      }),
   siteKey: yup.string().required()
})
